import useIsMobile from '@/hooks/use-is-mobile';
import { Tooltip } from 'antd';
import clsx from 'clsx';
import Link from 'next/link';
import { ReactNode } from 'react';

interface Props {
  mode?: 'link';
  label: string;
  swatch_data: { thumbnail: string | null; value: string | null } | null;
  isActive: boolean;
  href?: string;
  onClick?: () => void;
}

const ColorFilterItem = (props: Props) => {
  const { mode, label, swatch_data, isActive, href = '#', onClick } = props;
  const isMobile = useIsMobile();
  const blockStyle = swatch_data?.value
    ? /^#\S+$/.test(swatch_data.value)
      ? {
          backgroundColor: swatch_data.value,
        }
      : {
          backgroundImage: `url(${process.env.NEXT_PUBLIC_BASE_PATH}/media/attribute/swatch/swatch_thumb/110x90${swatch_data.value})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
        }
    : {};

  const className = clsx(
    'w-[22px] h-[22px] rounded-[50%] relative cursor-pointer',
    isActive
      ? clsx(
          'after_border-80583F',
          " after_content-[''] after_w-[26px] after_h-[26px] after_rounded-[50%] after_absolute",
          'after_left-1/2 after_top-1/2 after_-translate-x-1/2 after_-translate-y-1/2',
          'after_border-1 after_border-solid ',
        )
      : '',
    'block',
    label === 'White' && 'border-1 border-solid border-[#ddd]',
  );

  if (isMobile) {
    return (
      <div
        onClick={() => {
          onClick?.();
        }}
        className='flex h-[50px] w-full items-center justify-start gap-x-2.5 border-b-1 border-solid border-E7DED5'
      >
        <div
          className={className}
          style={blockStyle}
        />
        <span className='text-sm leading-5'>{label}</span>
      </div>
    );
  }

  let node: ReactNode = null;

  if (mode === 'link') {
    node = (
      <Link
        href={href}
        className={className}
        style={blockStyle}
        onClick={() => {
          onClick?.();
        }}
        data-filter-link='1'
      />
    );
  } else {
    node = (
      <div
        className={className}
        style={blockStyle}
        onClick={() => {
          onClick?.();
        }}
      />
    );
  }

  return (
    <Tooltip
      title={label}
      placement='top'
    >
      {node}
    </Tooltip>
  );
};

export default ColorFilterItem;
